import React from 'react';
import './Footer.css'; // Import the CSS file

const Footer = () => {
  return (
    <footer>
      <p>&copy; 2024 News Website</p>
    </footer>
  );
};

export default Footer;
